
import Table from "./CommonUserTable";


function Users() {
  return (
    <div>
      <Table role={1} />
    </div>
  );
}

export default Users;
